import { useDispatch, useSelector } from 'react-redux';
import dynamicfunction from '../../utils/dynamicfunction';
import { useEffect, useState } from 'react';
import { createTransfer, getFeeWithdrawal, getTransferInfo, getTransferTransaction } from '../../store/actions/transferAction';
import { getContentKeyAccToLang } from '../../utils/utils';
import { useLocation, useNavigate } from 'react-router';
import dayjs from 'dayjs';
import { generateGeneralOtp } from '../../store/actions/common-action';
import { clientSuspendedToast } from '../../utils/functions';
import { getClientData } from '../../store/actions/investmentsAction';

export default () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const pathname = useLocation();
  const { transferLoading, transactionLoading, transferInfo, transactionList, fee_withdrawal } = useSelector(
    (state) => state.transfer
  );

  const { clientDetails } = useSelector(
    (state) => state.investments
  );

  const { user } = useSelector((state) => state.common);

  const { transferContent } = useSelector((state) => state.content);
  const { TextWeight, isArabic, direction } = dynamicfunction();

  const [transferData, setTransferData] = useState(null);
  const [isShowModal, setIsShowModal] = useState(false);
  const [otpModal, setOtpModal] = useState(false);

  useEffect(() => {
    getData();
  }, []);

  const isTransfers = pathname?.pathname === '/transfers/transfer';

  useEffect(() => {
    if (user?.isClientSuspended && (isTransfers)) {
      clientSuspendedToast(isArabic);
      navigate(-1)
    }
  }, [user?.isClientSuspended])

  const getData = async () => {
    await dispatch(getTransferInfo());
    await dispatch(getClientData());
    await onSearchTransactions();
  }

  const getContentKey = (key, isColon = false) => {
    return getContentKeyAccToLang(transferContent?.web_transfer_tab?.data?.attributes, key, isArabic, isColon);
  };

  const onSubmitTransfer = (values, resetForm) => {
    const api_data = {
      beneficiaryId: values?.to?.id,
      amount: Number(values?.amount),
      reasonId: Number(values?.reason?.id),
      otherReason: values?.other_reason || '',
      code: values?.to?.code,
      // isSameDay: values?.is_same_day,
      resetForm,
    };
    dispatch(getFeeWithdrawal(`${api_data?.amount}&beneficiaryId=${api_data?.beneficiaryId}`, () => {
      setTransferData(api_data);
      toogleModal();
    }));


  };

  const onVerify = () => {
    dispatch(
      createTransfer(transferData, () => {
        transferData?.resetForm();
        dispatch(getTransferInfo());
        toogleModal();
        onSearchTransactions(null);
      })
    );
  };

  const onSearchTransactions = (values) => {
    const dateFrom = values?.from_date && dayjs(values?.from_date).startOf()?.format("YYYY-MM-DDT00:00:00");
    const dateTo = values?.to_date && dayjs(values?.to_date).format('YYYY-MM-DDT00:00:00');

    const params = `?pageNumber=1&pageSize=30${dateFrom ? `&entryDateFrom=${dateFrom}` : ''}${dateTo ? `&entryDateTo=${dateTo}` : ''}`;

    dispatch(getTransferTransaction(params));
  };

  const onReviewSubcription = () => {
    dispatch(generateGeneralOtp(4));
    toogleOtpModal();
  };

  const toogleModal = () => setIsShowModal(!isShowModal);
  const toogleOtpModal = () => setOtpModal(!otpModal);

  const totalAmount = fee_withdrawal?.transferFee + transferData?.amount;
  const availableBalance = clientDetails?.clientInformation?.accountBalance;
  return {
    TextWeight,
    isArabic,
    direction,
    transferLoading,
    transferInfo,
    availableBalance,
    transactionList,
    isShowModal,
    transferData,
    transactionLoading,
    dispatch,
    getContentKey,
    onSubmitTransfer,
    onSearchTransactions,
    toogleModal,
    navigate,
    otpModal,
    toogleOtpModal,
    onVerify,
    onReviewSubcription,
    totalAmount,
    fee_withdrawal,
  };
};
